// ** Initial State
const initialState = {
  suggestions: [],
  bookmarks: [],
  query: '',
  navbar: false,
  searching: false,
  error: false,
  loading: false
}

const navbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'NAV_TOGGLE': {
      return { ...state, navbar: action.value }
    }
    case 'NAV_LASTQ_ERROR': {
      return { ...state, error: action.value }
    }
    case 'NAV_LASTQ_LOADING': {
      return { ...state, loading: action.value }
    }
    case 'CLEAR_NAV_RESULTS': {
      return { ...state, suggestions: [], error: false }
    }
    case 'S_SEARCHING_V': {
      return { ...state, searching: action.value }
    }
    case 'NAV_SEARCH_RESULTS':
      return { ...state, suggestions: action.value }
    case 'HANDLE_SEARCH_QUERY':
      return { ...state, query: action.val }
    case 'GET_BOOKMARKS':
      return { ...state, suggestions: action.data, bookmarks: action.bookmarks }
    case 'UPDATE_BOOKMARKED': {
      let objectToUpdate

      // ** find & update object
      state.suggestions.find((item) => {
        if (item.id === action.id) {
          item.isBookmarked = !item.isBookmarked
          objectToUpdate = item
        }
      })

      // ** Get index to add or remove bookmark from array
      const bookmarkIndex = state.bookmarks.findIndex((x) => x.id === action.id)

      if (bookmarkIndex === -1) {
        state.bookmarks.push(objectToUpdate)
      } else {
        state.bookmarks.splice(bookmarkIndex, 1)
      }

      return { ...state }
    }
    default:
      return state
  }
}

export default navbarReducer
